
export class Sld {
    public name: string|undefined;
    public id: number|undefined;
    public builtin: boolean = false;

    public singleBand: boolean = true;
    public gray: ChannelSelection|undefined;
    public red: ChannelSelection|undefined;
    public green: ChannelSelection|undefined;
    public blue: ChannelSelection|undefined;
    public colormap: ColorMapEntry[] = [];

    hasChannelSelection(): boolean {
        if (this.gray) {
            return true;
        } else if (this.red && this.green && this.blue) {
            return true;
        }
        return false;
    }

    copy(): Sld {
        return Sld.from(structuredClone(this));
    }

    static from(data:Sld) {
        return Object.assign(new Sld(), data);
    }
    // Convert JSON object to Sld object
    static fromJson(json:any): Sld|undefined {
        if (json) {
            let sld = new Sld();
            if (json.singleBand) {
                sld.singleBand = json.singleBand;
            }
            if (json.name) {
                sld.name = json.name;
            }
            if (json.id) {
                sld.id = json.id;
            }
            if (json.builtin) {
                sld.builtin = json.builtin;
            }
            if (json.gray) {
                sld.gray = new ChannelSelection(json.gray.bandnumber, json.gray.minvalue, json.gray.maxvalue);
            }
            if (json.red) {
                sld.red = new ChannelSelection(json.red.bandnumber, json.red.minvalue, json.red.maxvalue);
            }
            if (json.green) {
                sld.green = new ChannelSelection(json.green.bandnumber, json.green.minvalue, json.green.maxvalue);
            }
            if (json.blue) {
                sld.blue = new ChannelSelection(json.blue.bandnumber, json.blue.minvalue, json.blue.maxvalue);
            }
            if (json.colormap) {
                for (let item of json.colormap) {
                    if ('quantity' in item && 'color' in item && 'alpha' in item) {
                        sld.colormap.push(new ColorMapEntry(item.quantity, item.color, Number(item.alpha)));
                    } else if ('quantity' in item && 'color' in item) {
                        sld.colormap.push(new ColorMapEntry(item.quantity, item.color));
                    }
                }
            }
            return sld;
        }
        return undefined;
    }
}

export class ColorMapEntry {
    public quantity: string;
    public color: string;
    public alpha: number;

    constructor(quantity:string, color:string, alpha:number=1.0) {
        this.quantity = quantity;
        this.color = color;
        this.alpha = alpha;
    }
}

export class ChannelSelection {
    public bandnumber: number;
    public minvalue: number|undefined;
    public maxvalue: number|undefined;

    constructor(bandnumber:string, minvalue:string|undefined, maxvalue:string|undefined) {
        this.bandnumber = parseInt(bandnumber);
        if (minvalue && minvalue != '') {
            this.minvalue = parseInt(minvalue);
        }
        if (maxvalue && maxvalue != '') {
            this.maxvalue = parseInt(maxvalue);
        }
    }
}